export default [
  {
    path: '/home',
    name: 'portalHome',
    component: () => import(/* webpackChunkName: "portal" */ '../views/portal/home/IndexView.vue'),
    meta: {
      nameCN: '首页',
      showInNav: true,
    }
  },
  {
    path: '/information',
    name: 'portalInformation',
    component: () => import(/* webpackChunkName: "portal" */ '../views/portal/information/IndexView'),
    meta: {
      nameCN: '行业资讯',
      showInNav: true,
    }
  },
  {
    path: '/service',
    name: 'portalService',
    component: () => import(/* webpackChunkName: "portal" */ '../views/portal/server/IndexView'),
    meta: {
      nameCN: '服务大厅',
      showInNav: true,
    }
  },
  {
    path: '/service/mean-detail',
    name: 'portalMeanDetail',
    component: () => import(/* webpackChunkName: "portal" */ '../views/portal/server/MeansDetail'),
    meta: {
      nameCN: '农资农机详情',
      showInNav: false,
    }
  },
  {
    path: '/service/expert-detail',
    name: 'portalExpertDetail',
    component: () => import(/* webpackChunkName: "portal" */ '../views/portal/server/ExpertDetail'),
    meta: {
      nameCN: '专家详情',
      showInNav: false,
    }
  },
  {
    path: '/needs',
    name: 'portalNeeds',
    component: () => import(/* webpackChunkName: "portal" */ '../views/portal/needs/IndexView'),
    meta: {
      nameCN: '需求大厅',
      showInNav: true,
    }
  },
  {
    path: '/needs/detail',
    name: 'portalNeedsDetail',
    component: () => import(/* webpackChunkName: "portal" */ '../views/portal/needs/NeedsDetail'),
    meta: {
      nameCN: '详情',
      showInNav: false,
    }
  },
  {
    path: '/needs/supply-detail',
    name: 'portalSupplyDetail',
    component: () => import(/* webpackChunkName: "portal" */ '../views/portal/needs/SupplyDetail'),
    meta: {
      nameCN: '供应详情',
      showInNav: false,
    }
  },
  {
    path: '/needs/seeding-detail',
    name: 'portalSeedingDetail',
    component: () => import(/* webpackChunkName: "portal" */ '../views/portal/needs/SeedingDetail'),
    meta: {
      nameCN: '种苗详情',
      showInNav: false,
    }
  },
  {
    path: '/needs/warehousing-detail',
    name: 'portalWarehousingDetail',
    component: () => import(/* webpackChunkName: "portal" */ '../views/portal/needs/WarehousingDetail'),
    meta: {
      nameCN: '详情',
      showInNav: false,
    }
  },
  {
    path: '/technology',
    name: 'portalTechnology',
    component: () => import(/* webpackChunkName: "portal" */ '../views/portal/technology/IndexView'),
    meta: {
      nameCN: '农技学堂',
      showInNav: true,
    }
  },
  {
    path: '/technology/detail',
    name: 'portalTechnologyDetail',
    component: () => import(/* webpackChunkName: "portal" */ '../views/portal/technology/TechnologyDetail'),
    meta: {
      nameCN: '农技学堂详情',
      showInNav: false,
    }
  },
  {
    path: '/enterprises',
    name: 'portalEnterprises',
    component: () => import(/* webpackChunkName: "portal" */ '../views/portal/enterprises/IndexView'),
    meta: {
      nameCN: '企业展示',
      showInNav: true,
    }
  },
  {
    path: '/enterprises/detail',
    name: 'portalEnterprisesDetail',
    component: () => import(/* webpackChunkName: "portal" */ '../views/portal/enterprises/EnterprisesDetail'),
    meta: {
      nameCN: '企业详情',
      showInNav: false,
    }
  },
  {
    path: '/enterprises/projectDetail',
    name: 'portalProjectDetail',
    component: () => import(/* webpackChunkName: "portal" */ '../views/portal/enterprises/ProjectDetail'),
    meta: {
      nameCN: '项目详情',
      showInNav: false,
    }
  },
  {
    path: '/information/detail',
    name: 'portalInformationDetail',
    component: () => import(/* webpackChunkName: "portal" */ '../views/portal/information/InformationDetail'),
    meta: {
      nameCN: '资讯详情',
      showInNav: false
    }
  },
  {
    path: '/information/quotation/detail',
    name: 'portalQuotationDetail',
    component: () => import(/* webpackChunkName: "portal" */ '../views/portal/information/QuotationDetail'),
    meta: {
      nameCN: '行情详情',
      showInNav: false,
    }
  },
  {
    path: '/about',
    name: 'portalAbout',
    component: () => import(/* webpackChunkName: "portal" */ '../views/portal/about/IndexView'),
    meta: {
      nameCN: '关于我们',
      showInNav: true,
    }
  },
  {
    path: '/search',
    name: 'portalSearch',
    component: () => import(/* webpackChunkName: "portal" */ '../views/portal/search/ResultView'),
    meta: {
      nameCN: '搜索结果',
      showInNav: false,
    }
  },
];
